/* angular:styles/component:css;8062ad595970b5bf5d8f549aecae326caa6a50e13ad6791a7216822752df9856;/app/frontend_mobile/src/app/components/buttons/avvia-ricarica/avvia-ricarica.component.ts */
/*# sourceMappingURL=avvia-ricarica.component.css.map */
